export default __webpack_public_path__ + "static/16-347ee574c5322acb49bf7807d9c14903.jpg";